import { useQuery } from '@tanstack/react-query';
import { LIST_BADGE_LIFECYCLE_STATE } from '@terra/shared-dto-types';
import type {
  FindingSeverityType,
  TargetTypeType,
} from '@terra/shared-schemas-orchestrator';
import { FINDING_SEVERITY_POSTURE_ORDER } from '../../components/dashboard/posture-items';
import { countFindingsForTarget } from '../api/target-findings-api';

export function useTargetFindingsSeverityCounts({
  targetId,
  targetType,
}: {
  targetId: string | null;
  targetType: TargetTypeType;
}) {
  return useQuery({
    queryKey: ['target-findings-severity-counts', targetType, targetId],
    queryFn: async (): Promise<Record<FindingSeverityType, number>> => {
      const counts = await Promise.all(
        FINDING_SEVERITY_POSTURE_ORDER.map((severity) =>
          countFindingsForTarget({
            targetId: targetId ?? '',
            targetType,
            filter: {
              lifecycleState: LIST_BADGE_LIFECYCLE_STATE,
              severity: [severity],
            },
          }),
        ),
      );
      const [Critical = 0, High = 0, Medium = 0, Low = 0, Info = 0] = counts;

      return { Critical, High, Medium, Low, Info };
    },
    enabled: Boolean(targetId),
    staleTime: 30_000,
  });
}
